import React, { useEffect, useState } from "react";
import StatCard from "./components/StateCard";
import CategoryChart from "./components/CategoryChart";
import CountrySalesCard from "./components/CountrySalesCard";
import RecentOrders from "./components/RecentOrders";
import {
  ShoppingBag,
  PackageCheck,
  PackageX,
  Clock3,
} from "lucide-react";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import ActionPermission from "../../utils/ActionPermission";
const Dashboard = () => {
  const [order, setOrder] = useState({});
  const getDatshboardData = async () => {
    try{
      const response=await axiosInstance.get("dashboard/getDashboard");
        setOrder(response.data.data);
    }catch(err){
      setOrder({});
      toast.error(err.response?.data?.message || "Something went wrong.");
    }
  }

  useEffect(() => {
    getDatshboardData();
  }, []);

  return (
      <ActionPermission pageKey="Dashboard" action="View" fallback={ <div className="content-wrapper"> <h1>Dashboard</h1> </div> }>
    <div className="content-wrapper">
      <div className="page-header m-0">
        <h3 className="custom-page-title">Dashboard</h3>
      </div>
   <div className="card border-0 shadow-sm rounded-4 dashboard-wrapper">
  <div className="card-body p-4">
    <div className="row g-4">
      <div className="col-xl-3 col-lg-6 col-md-6">
        <StatCard
          title="Total Orders"
          value={order?.totalOrders || 0}
          bgGradient="linear-gradient(135deg,#4E342E,#6D4C41)"
          iconBg="#ffffff20"
          trend="+12%"
          positive
           Icon={ShoppingBag}
        />
      </div>

      <div className="col-xl-3 col-lg-6 col-md-6">
        <StatCard
          title="Confirmed Orders"
          value={order?.confirmedOrder || 0}
          bgGradient="linear-gradient(135deg,#8D6E63,#A1887F)"
          iconBg="#ffffff20"
          trend="+8%"
          positive
           Icon={PackageCheck}
        />
      </div>

      <div className="col-xl-3 col-lg-6 col-md-6">
        <StatCard
          title="Cancelled Orders"
          value={order?.cancelOrder || 0}
          bgGradient="linear-gradient(135deg,#B85C38,#D2691E)"
          iconBg="#ffffff20"
          trend="-3%"
          positive={false}
           Icon={PackageX}
        />
      </div>

      <div className="col-xl-3 col-lg-6 col-md-6">
        <StatCard
          title="Pending Orders"
          value={order?.pendingOrder || 0}
          bgGradient="linear-gradient(135deg,#6F4E37,#8B5E3C)"
          iconBg="#ffffff20"
          trend="+5%"
          positive
            Icon={Clock3}
        />
      </div>
    </div>
  </div>
</div>

<div className="row mt-4">
  <div className="col-lg-6 col-md-6 col-12">
    <div className="card shadow-sm border-0 rounded-4 h-100">
      <div className="card-body">
        <CategoryChart data={order?.categoryData || []}/>
      </div>
    </div>
  </div>


  <div className="col-lg-6 col-md-6 col-12">
    <div className="card shadow-sm border-0 rounded-4 h-100">
      <div className="card-body">
        <CountrySalesCard data={order?.topCountries || []}/>
      </div>
    </div>
</div>


<div className="col-lg-12 col-md-6 col-12 mt-4">
  <RecentOrders  data={order?.latestOrders || []} />
</div>
</div>
    </div>

      </ActionPermission>
  );
};

export default Dashboard;
